<template>
  <div>
    <AlertDismiss ref="alertDismiss"></AlertDismiss>

    <b-pagination v-model="filter.page" :total-rows="rows" :per-page="filter.pageSize"
                  aria-controls="table-list-document" class="m-2" pills>
    </b-pagination>
  </div>
</template>
<script>
import { EventNames, InitPageSize } from '@/plugins/enums/index.js'
import { mapActions } from 'vuex';
import AlertDismiss from '@/components/shared/Alert-dismiss.vue'

export default {
  name: 'KarinPagination',

  data() {
    return {
      filter: {
        page: 1,
        pageSize: InitPageSize.KarinDenouncePageSize
      },

      rows: 0
    }
  },

  async mounted() {
    await this.getKarinDenounceCount();


    await this.paginationFilterKarinDenouonce();
  },

  components: {
    AlertDismiss
  },

  methods: {
    ...mapActions(["countKarinDenunciation"]),

    paginationFilterKarinDenouonce() {
      this.$eventBus.$emit(EventNames.PaginationFilterKarinDenounce, this.filter);
    },
    
    async getKarinDenounceCount() {
      let result = await this.countKarinDenunciation();
      if (result.isError) {
        this.$refs.alertDismiss.showAlert(result.message);
        return;
      }
    
      this.rows = result.data;
    }
  },

  watch: {
    //cada ves que se haga un click al paginador entonces emite el evento
    async "filter.page"() {
      this.paginationFilterDocument();
    },
  },
}
</script>
<style>

</style>
